import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Cftv } from "app/models/cftv.model";
import { Observable } from "rxjs";

export abstract class AbCftv extends AppService {
  abstract prefixo: string;
  abstract salvar(cftv: Cftv): Observable<any>;
  abstract getAllCftvs(filter: AppFilter): Observable<any>;
  abstract getCftvId(id: number): Observable<any>
  abstract desativar(id: number);
  abstract getAllFabricantesAtivos();
  abstract getAllModelosPorFabricante(fabricanteId: number);
  abstract testeConexao(cftv: Cftv);
}